import { FeatureFlagBool } from '../FeatureFlagBool';
import { FeatureFlagOverrideEntry, FeatureFlagOverrideStore } from './featureFlagOverrideTypes';

export type BooleanFeatureFlagSource = 'LOCAL_OVERRIDE' | 'LAUNCHDARKLY';

type LaunchDarklyFeatureFlagValue = boolean | number | string | null;

interface LaunchDarklyFeatureFlags {
  readonly [flagKey: string]: LaunchDarklyFeatureFlagValue;
}

export type ResolvedBooleanFeatureFlag = {
  value: boolean;
  source: BooleanFeatureFlagSource;
  override?: FeatureFlagOverrideEntry;
};

type ResolveBooleanFeatureFlagInput = {
  serverFlags: LaunchDarklyFeatureFlags;
  overrideStore: FeatureFlagOverrideStore;
  flagKey: FeatureFlagBool;
};

const getLocalBooleanOverride = (
  overrideStore: FeatureFlagOverrideStore,
  flagKey: FeatureFlagBool
): FeatureFlagOverrideEntry | undefined => {
  return overrideStore.entries.find((entry) => entry.override.type === 'BOOLEAN' && entry.override.key === flagKey);
};

export const resolveBooleanFeatureFlag = ({
  serverFlags,
  overrideStore,
  flagKey,
}: ResolveBooleanFeatureFlagInput): ResolvedBooleanFeatureFlag => {
  if (serverFlags['MLOnly']) {
    const override = getLocalBooleanOverride(overrideStore, flagKey);
    if (override && override.override.type === 'BOOLEAN') {
      return {
        value: override.override.value,
        source: 'LOCAL_OVERRIDE',
        override,
      };
    }
  }

  return {
    value: Boolean(serverFlags[flagKey]),
    source: 'LAUNCHDARKLY',
  };
};
